export function canUseGuestReviewBridge(params: URLSearchParams, verifyStatus: number | null): boolean {
  return params.get('review') === 'guest' && verifyStatus === 401;
}
